export const STORE_CONTEXT = "redux-store-context";

export const INTERNAL_STORE_UTILITY_DOMAIN = "@internal_storeUtility";